import React from 'react';

const NavBarContext = React.createContext(null);

export default NavBarContext;